import React ,{Component} from 'react';
import axios from 'axios';



export default class AccessPageMessage extends Component {
constructor(props) {
    super(props);
	
	
   
}




	


  
render() {


  return (
    <React.Fragment>
     
	<div style={{ textAlign: "center", marginTop: "150px" }}>
        <h2>🚫 Access Denied</h2>
        <p style={{ textAlign: "center"}} >You don’t have permission to view this page.</p>
        <a href="#/Login">Go back to Login</a>
      </div>
	  
	  
    </React.Fragment>
  );
}
}